import { Table } from "@/features/Table";
import { Clients } from "@/lib/clients";
import { type E2Position, e2_positions_columns } from "./columns";
import { type FilterE2PositionsSchema, FilterE2Positions } from "./filter";
import { Tables } from "@/gen/tableNames/tables";

export const E2PositionsTable = () => {
  return (
    <Table<E2Position, FilterE2PositionsSchema>
      label="Positions"
      client={Clients.E2}
      table_name={Tables.E2_POSITIONS}
      columns={e2_positions_columns}
      filter={<FilterE2Positions />}
      actions={[
        {
          label: "actions.new",
          route: `${Clients.E2}/${Tables.E2_POSITIONS}/new`,
        },
      ]}
    />
  );
};
